A position to be synchronized.
